import { DateForm } from './DateForm.jsx';

import { useDateForm } from './useDateForm';

export const DateStep = ({ campaign }) => {
  const {
    uuid,
    startDate,
    endDate,
    posts,
    multiMonth,
    isArchived,
    deletedAt,
  } = campaign;
  const hasLivePosts = posts.some(post => post.status === 'live');
  const disabled = hasLivePosts || isArchived || !!deletedAt;
  const { values, handleDateUpdate, resetForm } = useDateForm({
    id: uuid,
    startDate,
    endDate,
  });

  return (
    <DateForm
      resetForm={resetForm}
      disabled={disabled}
      handleDateUpdate={handleDateUpdate}
      campaignStartDate={values.startDate}
      campaignEndDate={values.endDate}
      multiMonth={multiMonth}
    />
  );
};
